var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.912c0-.688.56-1.255 1.24-1.153a8.333 8.333 0 1 1-8.636 4.4c.317-.61 1.106-.73 1.662-.325s.665 1.18.388 1.809a5.843 5.843 0 1 0 6.582-3.354C10.564 4.144 10 3.599 10 2.912",
    clipRule: "evenodd"
  })));
};
export default SvgSpinner;